<template>
  <!--
    Ícono "sparkles" del Asistente de IA. Antes era el SVG inline (el mismo path repetido en
    AiAssistantModal.vue, AiSuggestionIcon.vue y Tab3.vue); ahora usa los assets reales del
    proyecto, igual que el resto de los íconos de la app (ver Navigation.vue).

    Son DOS archivos y no uno pintado con currentColor porque no son el mismo dibujo con otro
    color: sparklesViolet.svg (el que exportó diseño desde Figma) trae un DEGRADADO violeta que
    currentColor no puede reproducir, y sparkles-white.svg es la versión plana blanca para
    cuando el ícono va encima del violeta (el círculo del bot, el chip "Usar IA", el botón
    "Usar Esta Versión").
  -->
  <img
    v-if="variant === 'white'"
    src="@/assets/img/sparkles-white.svg"
    class="ai-spark-icon"
    :width="size"
    :height="size"
    alt=""
    aria-hidden="true"
  />
  <img
    v-else
    src="@/assets/img/sparklesViolet.svg"
    class="ai-spark-icon"
    :width="size"
    :height="size"
    alt=""
    aria-hidden="true"
  />
</template>

<script>
export default {
  name: 'AiSparkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
    // 'violet' (por defecto, sobre fondo claro) | 'white' (sobre el gradiente violeta).
    variant: {
      type: String,
      default: 'violet',
      validator: (value) => ['violet', 'white'].includes(value),
    },
  },
};
</script>

<style scoped>
.ai-spark-icon {
  /* flex: none para que no se encoja dentro de los botones/títulos que son flex. */
  display: inline-block;
  flex: none;
}
</style>
